import _axios from 'axios'
import getEnv from '@/utils/env'
const url = action => `/${action}`

//import api from '@/services/api'

export async function postApiLogin(params){

    const axios = _axios.create({
        baseURL: `${getEnv('VUE_APP_API_BASE_URL')}/api`,
        responseType: 'json',
        timeout: 30000
    })
    var client_name = `${getEnv('VUE_APP_CLIENT_NAME')}`
    var client_secret = `${getEnv('VUE_APP_CLIENT_SECRET')}`
    //console.log(client_name, 'client_name')
    //console.log(client_secret, 'client_secret')
    axios.interceptors.request.use(
        config => {
            config.headers = {
                "client_name": `${client_name}`,
                "client_secret": `${client_secret}`
            };
            return config;
        },
        error =>{
            return Promise.reject(error);
        }
    )
    
    const { data: res } = await axios.post(url('login'), params)
    return res
}

export async function getApiUserInformation(params){
    //console.log(params,'login.js-getApiUserInformation')
    const axios = _axios.create({
        baseURL: `${getEnv('VUE_APP_API_BASE_URL')}/api`,
        responseType: 'json',
        timeout: 30000
    })
    axios.interceptors.request.use(
        config => {
            config.headers.Authorization= `Bearer ${params}`;           
            return config;
        },
        error =>{
            return Promise.reject(error);
        }
    )
    
    const {data:res} = await axios.get(url('info'))
    
    //const {data:res} = await api.get(url('info'))
    return res
}